import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from "./component/Employee/login";
import SignUp from "./component/Employee/signup";
import ScheduleSelection from "./component/Employee/schedule_selection"
import ManagerSignup from "./component/Manager/manager_signup";
import ManagerLogin from "./component/Manager/manager_login";
import ManagerDashboard from "./component/Manager/manager_dashboard";
import Home from "./component/home";
import SuperDashboard from "./component/SuperAdmin/super_dashboard";
import SuperSignup from "./component/SuperAdmin/super_signup"
import SuperLogin from "./component/SuperAdmin/super_login"

function App() {
  return (
    <Router>
      <div>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/manager_signup" element={<ManagerSignup />} />
          <Route path="/manager_login" element={<ManagerLogin />} />
          <Route path="/manager_dashboard" element={<ManagerDashboard />} />
          <Route path="/schedule_selection" element={<ScheduleSelection />} />
          <Route path="/home" element={<Home />} />
          <Route path="/super_dashboard" element={<SuperDashboard />}/>
          <Route path="/super_signup" element={<SuperSignup />}/>
          <Route path="/super_login" element={<SuperLogin />}/>
        </Routes>
      </div>
    </Router>
  );
}

export default App;

